import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "SbHistoryNew bg-white rounded" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "border-b p-4 select-none" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "uppercase text-sm font-semibold" }, "История проверки СБ")
], -1)
const _hoisted_3 = { class: "p-4" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col items-center justify-center select-none text-sm text-gray-400"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Загрузка истории проверки СБ...", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, "При получении истории проверки СБ произошла ошибка", -1)
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = {
  key: 0,
  class: "fas fa-check text-green-500"
}
const _hoisted_11 = {
  key: 1,
  class: "fas fa-times text-red-500"
}
const _hoisted_12 = { class: "flex flex-col ml-4" }
const _hoisted_13 = { class: "font-semibold" }
const _hoisted_14 = { class: "text-sm text-gray-400" }
const _hoisted_15 = { class: "text-gray-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.state.is_loading || _ctx.state.is_failed || _ctx.state.history.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_ctx.state.is_loading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_loader, { class: "primary small" }),
                  _hoisted_5
                ], 64))
              : (_ctx.state.is_failed)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_6,
                    _createVNode(_component_the_button, {
                      class: "primary small mt-1",
                      onClick: _ctx.loadHistory
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Обновить")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ], 64))
                : (_ctx.state.history.length === 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, "Нет данных"))
                  : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.history, (history_record, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `HistoryRecord-${i}`,
                class: _normalizeClass(["p-4 rounded flex items-center justify-between", {
                        'mt-4': i !== 0,
                        'bg-green-50': history_record.isAccepted,
                        'bg-red-50': !history_record.isAccepted,
                    }])
              }, [
                _createElementVNode("div", _hoisted_9, [
                  (history_record.isAccepted)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_10))
                    : (_openBlock(), _createElementBlock("i", _hoisted_11)),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.getTitle(history_record.isAccepted)), 1),
                    _createElementVNode("span", _hoisted_14, _toDisplayString(history_record.comment || 'Комментарий не указан'), 1)
                  ])
                ]),
                _createElementVNode("span", _hoisted_15, _toDisplayString(history_record.createdAt), 1)
              ], 2))
            }), 128))
          ]))
    ])
  ]))
}